<template>
  <div class="editor">
    <div class="query-container" style="padding-bottom: 20px">
      <el-select v-model="params.flCode" placeholder="模板分类" clearable>
        <el-option v-for="item in flCodeOpts" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <el-select v-model="params.isAdmin" style="margin-left: 8px" placeholder="仅管理员发送" clearable>
        <el-option v-for="item in adminOpts" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <el-select v-model="params.emergency" style="margin-left: 8px" placeholder="紧急程度" clearable>
        <el-option v-for="item in emergencyObjs" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      <el-input v-model="params.name" style="width: 180px; margin-left: 8px" placeholder="模板名称" clearable
        @keyup.enter.native="query"></el-input>
      <el-input v-model="params.title" style="width: 180px; margin-left: 8px" placeholder="模板标题" clearable
        @keyup.enter.native="query"></el-input>

      <el-button type="primary" style="margin-left: 8px" @click="query">查询</el-button>
      <el-button type="primary" style="margin-left: 8px" @click="addNotice">创建模板</el-button>
      <el-button type="primary" style="margin-left: 8px" @click="sendSimpleNotice">发送简单消息</el-button>
      <el-button type="danger" plain style="margin-left: 8px" :disabled="!selection.length" @click="deleteSelected">
        删除选中{{ selection.length ? "（" + selection.length + "）" : "" }}
      </el-button>
    </div>

    <el-table ref="table" :data="pageRows" row-key="id" style="width: 100%" @selection-change="onSelectionChange">
      <el-table-column type="selection" width="48" reserve-selection> </el-table-column>
      <el-table-column prop="code" label="模板编码" width="80"> </el-table-column>
      <el-table-column prop="name" label="模板名称" width="200"> </el-table-column>
      <el-table-column prop="title" label="模板标题"> </el-table-column>
      <el-table-column label="模板分类" width="120">
        <template slot-scope="scope">
          {{ flName(scope.row.flCode) }}
        </template>
      </el-table-column>
      <el-table-column label="仅管理员发送" width="120">
        <template slot-scope="scope">
          {{ scope.row.adminSend ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="emergencyName" label="紧急程度" width="120"> </el-table-column>
      <el-table-column prop="needConfirm" label="是否需要确认" width="120">
        <template slot-scope="scope">
          {{ scope.row.needConfirm ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="200"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="320">
        <template slot-scope="scope">
          <el-button @click="editNotice(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="deleteNotice(scope.row)" type="text" size="small">删除</el-button>
          <el-button @click="showSendNotice(scope.row)" type="text" size="small">发送消息</el-button>
          <el-button @click="viewSent(scope.row)" type="text" size="small">查看发送</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="page.pageNo" :page-sizes="pageSizes" :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="page.total" @size-change="onPageSizeChange"
      @current-change="onPageNoChange" />

    <el-dialog :visible.sync="showNoticeEidt" title="消息模板设置" width="1120px" top="5vh"
      custom-class="notice-template-dialog" :close-on-click-modal="false" append-to-body>
      <NoticeEdit v-if="showNoticeEidt" :notice="currentNoticeTmp" @closeWindow="afterEditNotice"></NoticeEdit>
    </el-dialog>

    <el-dialog :visible.sync="showNoticeForm" title="发送消息" width="980px" top="6vh" custom-class="notice-send-dialog"
      :close-on-click-modal="false" append-to-body>
      <NoticeForm v-if="showNoticeForm" :notice="currentNoticeTmp" :sendData="sendData"
        @closeWindow="showNoticeForm = false"></NoticeForm>
    </el-dialog>

  </div>
</template>

<script>
import NoticeEdit from "./NoticeEdit";
import NoticeForm from "./NoticeForm";
import { SHOW_DRIVER_NOTICE_MODAL } from "@/core/const/global-event";
export default {
  name: "NoticeTemplate",
  components: {
    NoticeEdit,
    NoticeForm
  },
  data() {
    return {
      showNoticeEidt: false,
      showNoticeForm: false,
      currentNoticeTmp: {},
      tableData: [],
      selection: [],
      pageSizes: [20, 50, 100],
      page: {
        pageNo: 1,
        pageSize: 50,
        total: 0
      },
      noticeTypes: [],
      sendData: {},
      emergencyObjs: [
        { value: "1", label: "普通" },
        { value: "2", label: "重要" },
        { value: "3", label: "紧急" }
      ],
      flCodeOpts: [
        { value: "1", label: "" },
        { value: "2", label: "" }
      ],
      adminOpts: [
        { value: "1", label: "是" },
        { value: "0", label: "否" }
      ],
      params: { flCode: "", isAdmin: "", emergency: "", name: "", title: "" }
    };
  },
  computed: {
    pageRows() {
      const start = (this.page.pageNo - 1) * this.page.pageSize;
      return this.tableData.slice(start, start + this.page.pageSize);
    }
  },
  mounted() {
    this.initData();
    this.query();
  },
  methods: {
    initData() {
      window.emergencyObjs = this.emergencyObjs;
      this.$http.post("/admin/notice/initdata", {}).then((res) => {
        this.noticeTypes = res.data.noticeTypes || [];
        this.flCodeOpts = res.data.flCodeOpts || [];
        window.flCodeOpts = this.flCodeOpts;
        window.noticeTypes = this.noticeTypes;
      });
    },
    query() {
      this.page.pageNo = 1;
      this.initPage();
    },
    initPage() {
      this.$http.post("/admin/notice/listtemplate", this.params).then((res) => {
        this.tableData = res.data || [];
        this.tableData.forEach((template) => {
          for (var j = 0; j < this.emergencyObjs.length; j++) {
            let emergencyObj = this.emergencyObjs[j];
            if (template.emergency == emergencyObj.value) {
              template.emergencyName = emergencyObj.label;
            }
          }
        });
        this.page.total = this.tableData.length;
        const maxPage = Math.max(1, Math.ceil(this.page.total / this.page.pageSize));
        if (this.page.pageNo > maxPage) {
          this.page.pageNo = maxPage;
        }
        this.clearSelection();
      });
    },
    onSelectionChange(rows) {
      this.selection = rows || [];
    },
    clearSelection() {
      this.selection = [];
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.clearSelection();
        }
      });
    },
    onPageSizeChange(size) {
      this.page.pageSize = size;
      this.page.pageNo = 1;
    },
    onPageNoChange(pageNo) {
      this.page.pageNo = pageNo;
    },
    flName(code) {
      const hit = (this.flCodeOpts || []).find((item) => item.value == code);
      return hit ? hit.label : code || "";
    },
    editNotice(template) {
      this.showNoticeEidt = true;
      this.currentNoticeTmp = template;
    },
    afterEditNotice() {
      this.showNoticeEidt = false;
      this.initPage();
    },
    addNotice() {
      this.editNotice({});
    },
    deleteNotice(template) {
      this.$confirm("此操作将永久删除通知模板, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http.post("/admin/notice/deltemplate/" + template.id, {}).then(() => {
          this.$message.success("删除模板成功");
          this.initPage();
        });
      });
    },
    deleteSelected() {
      const ids = this.selection.map((row) => row.id).filter((id) => id);
      if (!ids.length) {
        return;
      }
      this.$confirm("将删除选中的 " + ids.length + " 条通知模板，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http.post("/admin/notice/deltemplates", ids).then(() => {
          this.$message.success("已删除 " + ids.length + " 条模板");
          this.initPage();
        });
      });
    },

    showSendNotice(template) {
      this.currentNoticeTmp = template;
      this.sendData = {};
      this.showNoticeForm = true;
    },
    sendSimpleNotice() {
      this.$bus.$emit(SHOW_DRIVER_NOTICE_MODAL, {});
    },
    viewSent(template) {
      this.$emit("view-send", {
        id: template.id,
        code: template.code,
        name: template.name
      });
    }
  }
};
</script>

<style lang="less" scoped>
.editor {
  padding: 12px 16px 16px;

  .query-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .el-pagination {
    margin-top: 12px;
  }
}
</style>

<style lang="less">
.notice-template-dialog {
  max-width: calc(100vw - 48px);

  .el-dialog__body {
    padding: 8px 16px 16px;
  }
}
</style>
